import { UserPermission } from './user-permission';
import { UserRoleMetadata } from 'src/app/utils/role.utils';
import { RoleUtils } from 'src/app/utils/role.utils';

export type UserType = 'unknown' | 'inspire' | 'client' | 'distributor';

export class UserDetails extends UserPermission {
  id?: string;
  type: UserType;
  email: string;
  name: string;
  groups: string[];
  
  private readonly _userRoleMetadata: UserRoleMetadata | null;
  
  constructor(data: {
    id?: string;
    type: UserType;
    email: string;
    name: string;
    groups: string[];
    permissions?: {
      key: string;
      name: string;
      description: string;
      requiredPermissions: string[];
      serviceKey: string;
    }[];
    services?: {
      key: string;
      name: string;
      description: string;
      isEnable: boolean;
    }[];
  }) {
    super();
    this.id = data.id;
    this.type = data.type;
    this.email = data.email;
    this.name = data.name;
    this.groups = data.groups;
    this.permissions = data.permissions;
    this.services = data.services;
    this._userRoleMetadata = RoleUtils.computeUserRoleMetadata(data.groups);
  }
  
  get isSAC(): boolean {
    return this._userRoleMetadata?.userApplications.size > 0 || false;
  }
  
  get isDCSAC(): boolean {
    return this._userRoleMetadata?.isDCSAC || false;
  }
  
  get isUMAdmin(): boolean {
    return this._userRoleMetadata?.isUMAdmin || false;
  }
  
  get applications(): Set<string> {
    return this._userRoleMetadata?.userApplications || new Set();
  }
  
  canViewRole(roleKey: string): boolean {
    if (!this._userRoleMetadata) {
      return false;
    }
    const roleApplicationId = RoleUtils.extractApplicationFromRole(roleKey);
    return RoleUtils.canUserAccessRoleOptimized(roleKey, roleApplicationId, this._userRoleMetadata);
  }
}

export interface CognitoUserInfo {
  username: string;
  email: string;
}

export interface User {
  created: string;
  email: string;
  enabled: boolean;
  modified: string;
  username: string;
  customStatus?: string;
  verified?: boolean;
  confirmationStatus?: string;
  role: string[];
  roles?: string;
  tenantIDs?: string[];
  createdDate?: Date;
  modifiedDate?: Date;
}
